// extracted by mini-css-extract-plugin
var _1 = "eIlF75vpBixErGN5iZHw";
var _2 = "sVzNPKznTyRZ8ch6dhAi";
var _3 = "y96IL46zIj2YKzxfAd1g";
var _4 = "WDkgOl1XNd38FjfaKYRH";
var _5 = "spkSYVFn9hCqxyDneQ_w";
var _6 = "#000000";
var _7 = "#76F366";
var _8 = "#EB8632";
var _9 = "#ECC834";
var _a = "#21FC87";
var _b = "#EA4A30";
var _c = "#C7EA45";
var _d = "#272B2B";
var _e = "#BDBDBD";
var _f = "#7D7D7D";
var _10 = "#6A0DAD";
var _11 = "#3A65FF";
var _12 = "#4A90E2";
var _13 = "#ffffff";
var _14 = "nlvFXd6rfkL9rbMIxNDF";
var _15 = "Iz2P1Lz8U8me6EHsBllZ";
var _16 = "K4ZJ6Of6exmxlxQKwDO8";
var _17 = "gG3uayleJmVkX3gWIGVs";
var _18 = "1200px";
var _19 = "992px";
var _1a = "1366px";
var _1b = "768px";
var _1c = "1475px";
var _1d = "576px";
var _1e = "1600px";
var _1f = "320px";
var _20 = "2500px";
var _21 = "klnjMlYNTTqK339BhFwh";
export { _1 as "active-media-preview", _2 as "alert", _3 as "alertClose", _4 as "alertIcon", _5 as "base-link", _6 as "colorBlack", _7 as "colorGradeEX", _8 as "colorGradeFR", _9 as "colorGradeGD", _a as "colorGradeOU", _b as "colorGradePR", _c as "colorGradeVG", _d as "colorNeutral", _e as "colorNeutralLighest", _f as "colorNeutralLight", _10 as "colorNonOwnerSweetLine", _11 as "colorOwnerSweetLine", _12 as "colorRegularLinks", _13 as "colorWhite", _14 as "iconError", _15 as "iconInfo", _16 as "iconWarning", _17 as "reset-button", _18 as "screenlg", _19 as "screenmd", _1a as "screenml", _1b as "screensm", _1c as "screenxlg", _1d as "screenxs", _1e as "screenxxlg", _1f as "screenxxs", _20 as "screenxxxlg", _21 as "single-page-responsive-font-size" }
export default { "active-media-preview": _1, "alert": _2, "alertClose": _3, "alertIcon": _4, "base-link": _5, "colorBlack": _6, "colorGradeEX": _7, "colorGradeFR": _8, "colorGradeGD": _9, "colorGradeOU": _a, "colorGradePR": _b, "colorGradeVG": _c, "colorNeutral": _d, "colorNeutralLighest": _e, "colorNeutralLight": _f, "colorNonOwnerSweetLine": _10, "colorOwnerSweetLine": _11, "colorRegularLinks": _12, "colorWhite": _13, "iconError": _14, "iconInfo": _15, "iconWarning": _16, "reset-button": _17, "screenlg": _18, "screenmd": _19, "screenml": _1a, "screensm": _1b, "screenxlg": _1c, "screenxs": _1d, "screenxxlg": _1e, "screenxxs": _1f, "screenxxxlg": _20, "single-page-responsive-font-size": _21 }
